import { Routes, Route } from "react-router-dom";
import { NotFoundScreen } from "screens/NotFoundScreen";
import ShipmentActionFollowupList from "components/ShipmentAction/ShipmentActionListFollowup";
import ShipmentActionBulkCreateScreen from "components/ShipmentAction/ShipmentActionBulkCreateScreen";
import NotificationActionListScreen from "screens/App/CRM/Notification/NotificationActionListScreen";

const ShipmentActionRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<ShipmentActionFollowupList />} />
      <Route path="create" element={<ShipmentActionBulkCreateScreen />} />
      <Route path="shipment-action" element={<NotificationActionListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ShipmentActionRouter;